<template>
    <form @submit.prevent="submitFeedback" ref="feedbackForm">
        <div class="form-group" :class="{ 'has-danger' : errors.includes('name') }">

            <div style="font-size: 14px; margin-bottom:12px" class="col-md-12">
                <div class="col-md-8">Bent u bereid mee te werken aan een klanttevredenheidsonderzoek<br/>aan het eind van dit traject?<span class="required-asterisk">*</span></div> 
                <div data-toggle="buttons" class="btn-group-toggle" style="position: absolute; right: 34px; top: 6px;">
                    <label class="btn" :class="myCandidateSurvey === 'true' ? 'active btn-success' : 'btn-secondary'" style="margin-right:4px">
                        <input type="radio" name="myCandidateSurvey" v-model="myCandidateSurvey" value="true"><i class="fa fa-check"></i>
                    </label> 
                    <label class="btn" :class="myCandidateSurvey === 'false' ? 'active btn-danger' : 'btn-secondary'">
                        <input type="radio" name="myCandidateSurvey" v-model="myCandidateSurvey" value="false"> <i class="fa fa-times"></i>
                    </label>
                </div>
            </div>
            
            <div v-for="question in questions">
                <question-base
                    v-model="question.answer"
                    :question="question"
                    @isBelowThreshold="setBelowThreshold"
                />
            </div>

            <label v-if="isBelowThreshold" class="col-md-12">
                <span class="col-md-6">{{ uLang('app.may_we_approach_you') }}</span>
                <question-boolean v-model="request_contact" class="col-md-2 pull-right" name="request_contact"></question-boolean>
            </label>

            

        </div>
        <button class="btn btn-brand pull-right" type="submit">{{ uLang('app.send') }}</button>
    </form>
</template>

<script>
import {
    ActionDocumentSelect,
    DualSelect,
    Input as FormInput,
    SettingSelect,
    Textarea as FormTextarea,
} from '~/Form/elements'
import FormMixin from '~/mixins/form'
import {mapGetters} from 'vuex'
import {ErrorAlert, SuccessAlert} from "~/Swals"
import QuestionBoolean from "../../../Form/elements/relation_feedback_form_elements/question-boolean";
import QuestionText from "../../../Form/elements/relation_feedback_form_elements/question-text";
import QuestionInteger from "../../../Form/elements/relation_feedback_form_elements/question-integer";
import QuestionBase from "../../../Form/elements/relation_feedback_form_elements/question-base";

export default {
    name: 'RelationFeedbackForm',

    mixins: [FormMixin],

    components: {
        QuestionBase,
        QuestionInteger,
        QuestionText,
        QuestionBoolean,
        FormInput,
        FormTextarea,
        DualSelect,
        SettingSelect,
        ActionDocumentSelect,
    },

    props: {
        enrolment_id: Number
    },

    data() {
        return {
            name: null,
            loading: false,
            errors: [],
            questions: [],
            below_threshold: false,
            request_contact: 'false',
            myCandidateSurvey: null,
        }
    },

    mounted() {
        this.name = this.user.full_name
        window.axios.get(route('relation.feedback.create')).then(({data}) => {
            // quick hack for validation
            this.questions = data.questions.map(function(el) {
                let o = Object.assign({}, el);
                o.answer = null;
                return o;
            })
        })
    },

    computed: {
        ...mapGetters({
            'user': 'authUser'
        }),
        isBelowThreshold() {
            return this.questions.some(function(question) {
                if (question.answer === '') {
                    return false
                }

                // Check if boolean questions are false
                if (question.type === 'boolean'){
                    return question.answer === 'false'
                }

                // Check if integer questions are below their threshold
                if (question.type === 'integer'){
                    return parseInt(question.answer) < parseInt(question.threshold)
                }
            })
        }
    },

    methods: {
        setBelowThreshold(value) {
            this.below_threshold = value
        },
        getInputType(type) {
            let inputType = ''
            switch (type) {
                case 'boolean':
                    inputType = 'radio';
                    break;
                case 'text':
                    inputType = 'text';
                    break;
                case 'integer':
                    inputType = 'number';
                    break;
                default:
                    inputType = 'text'
                    break;
            }
            return inputType
        },
        submitFeedback() {
            this.loading = true
            let runFinally = true

            window.axios.post(route('relation.feedback.store'), {
                questions: this.questions,
                enrolment_id: this.enrolment_id,
                request_contact: this.request_contact === 'true',
                relation_id: this.user.id,
                my_candidate_survey: this.myCandidateSurvey
            }).then(({data}) => {
                this.$emit('closeModal')
                let successText = this.uLang('app.thanks_for_the_feedback')

                if (this.request_contact === 'true') {
                    successText +=  '. ' + this.lang('app.contacting_soon')
                }

                return swal({
                    title: this.uLang('app.succeeded'),
                    text: successText,
                    icon: "success",
                    button: uLang('app.close'),
                    closeOnClickOutside: false,
                    closeOnEsc: false,
                    timer: 0
                }).then((result) => {
                    if (result) {
                        window.location.reload(true);
                    }
                });
            }).catch((error) => {
                if (error.response.status == 422) {
                    new ErrorAlert({title: this.uLang('app.please_fill_all_fields')}).show();
                    runFinally = false
                    return;
                }
                new ErrorAlert({text: this.uLang('app.feedback_sent_failure')}).show();
            }).finally(() => {
                if (runFinally) {
                    this.openModal = false
                    this.loading = false
                }
            })
        },
    },
}
</script>

<style lang="scss" scoped>
.required-asterisk {
    color: red;
}

.info-message {
    display: flex;
    align-items: center;

    i {
        padding-right: 15px;
    }

    p {
        flex: 1;
        margin-bottom: 0;
    }
}
</style>
